function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowNarrowLeft, ArrowNarrowRight } from "@ignite-analytics/icons";
import { paginationItemClasses } from "@mui/material/PaginationItem";
import { getBackgroundToken, getBorderToken, getButtonToken } from "../fundations/palette/colorTokens";
const MediumArrowNarrowLeft = ()=>{
    return /*#__PURE__*/ _jsx(ArrowNarrowLeft, {
        fontSize: "medium"
    });
};
const MediumArrowNarrowRight = ()=>{
    return /*#__PURE__*/ _jsx(ArrowNarrowRight, {
        fontSize: "medium"
    });
};
/**
 * @see https://www.figma.com/design/Tb6GgTuIDhCTiA132VuYT5/Ignite-Riddle?node-id=9848-291434
 * @see https://mui.com/material-ui/react-pagination
 */ export const Pagination = {
    MuiPagination: {
        defaultProps: {
            size: "large"
        },
        styleOverrides: {
            root: ()=>({
                    ["& li:first-of-type"]: {
                        [`& .${paginationItemClasses.previousNext}`]: {
                            borderRadius: "8px 0 0 8px"
                        }
                    },
                    ["& li:last-of-type"]: {
                        [`& .${paginationItemClasses.previousNext}`]: {
                            borderRadius: "0 8px 8px 0"
                        }
                    }
                })
        }
    },
    MuiPaginationItem: {
        defaultProps: {
            slots: {
                previous: MediumArrowNarrowLeft,
                next: MediumArrowNarrowRight
            }
        },
        styleOverrides: {
            root: ({ theme })=>_object_spread_props(_object_spread({
                    margin: 0,
                    padding: theme.spacing(1.5, 1.5),
                    background: `${getBackgroundToken("backgroundQuaternary", theme)}`,
                    border: `1px solid ${getBorderToken("border200", theme)}`,
                    borderRadius: 0
                }, theme.typography.textSm), {
                    [`&.${paginationItemClasses.ellipsis}`]: {
                        border: "none"
                    },
                    [`&.${paginationItemClasses.selected}`]: {
                        background: `${getButtonToken("buttonGhostGrayHover", theme)}`
                    }
                })
        }
    }
};

//# sourceMappingURL=Pagination.js.map